export default __webpack_public_path__ + "static/media/wakanda1.1b9637e6.jpg";